import { useState } from "react";

const useToggle = (initialValue = false) => {
  const [value, setValue] = useState(initialValue);

  return [value, () => setValue(val => !val), setValue];
};

export default useToggle;
